import React, { FC, useState } from 'react';

import { ModalFooter, ModalTitle, ModalHeader } from '@epoch-ui/components/Modal/modal';
import { Button } from '@epoch-ui/components/Button';
import { Switch } from '@epoch-ui/components/Switch/switch';

import { useGuestSideSheetContext } from '../../guestSideSheetContext';

import { usePlusOneGuestModalContext } from './plusOneGuestModalContext';

export const SetNotificationsContent: FC = () => {
  const [sendNotifications, setSendNotifications] = useState(false);

  const { state, dispatch, handleFinalSubmit, savingPlusOneGuest, settingSessionPlusOneGuests } =
    usePlusOneGuestModalContext();

  const {
    selectedPlusOneGuest: plusOneGuest,
    guestData: { guest }
  } = useGuestSideSheetContext();

  const ownerGuestFirstName = guest.firstName;
  const isEditMode = !!plusOneGuest?.plusOneId || state.previousStep === 'selectGuest';
  return (
    <>
      <ModalHeader className="tw-m-0 tw-text-black">
        <ModalTitle className="tw-mb-0 tw-text-2xl tw-font-medium">
          Send update notifications?
        </ModalTitle>
      </ModalHeader>
      <div className="tw-space-y-4 tw-text-black">
        <span className="tw-leading-5">
          Let {ownerGuestFirstName} know{' '}
          {isEditMode
            ? "their plus one guest's RSVP has been updated"
            : 'they have a new plus one guest'}
          .
        </span>
        <div className="tw-flex tw-items-start tw-gap-4 tw-self-stretch">
          <div className="tw-flex tw-flex-col tw-gap-1">
            <span id="send-notifications-label" className="tw-font-medium">
              Send update notifications
            </span>
            <span className="tw-text-xs tw-leading-4 tw-text-primary-grey">
              Update notifications will be sent in accordance with the guest&apos;s{' '}
              <a
                href="https://help.epochapp.com/articles/update-your-profile-and-settings"
                target="_blank"
                rel="noreferrer"
              >
                notification settings
              </a>
            </span>
          </div>
          <Switch
            checked={sendNotifications}
            onCheckedChange={setSendNotifications}
            aria-labelledby="send-notifications-label"
          />
        </div>
      </div>
      <ModalFooter className="tw-mt-0 tw-flex tw-flex-row tw-justify-end tw-text-black">
        <div className="tw-flex tw-flex-row tw-justify-center tw-gap-4">
          <Button
            size="sm"
            onClick={() => dispatch({ type: 'BACK_FROM_NOTIFICATIONS' })}
            className="tw-flex-1 tw-rounded-xl"
            variant="secondary"
          >
            Back
          </Button>
          <Button
            size="sm"
            loading={
              state.previousStep === 'selectGuest'
                ? settingSessionPlusOneGuests
                : savingPlusOneGuest
            }
            className="tw-flex-1 tw-rounded-xl"
            variant="primary"
            onClick={() => handleFinalSubmit(sendNotifications)}
          >
            {isEditMode ? 'Save changes' : 'Add guest'}
          </Button>
        </div>
      </ModalFooter>
    </>
  );
};
